/**
 * The message a failed request should actually show.
 *
 * authAxios has no interceptors (apiAxios does), so a rejected auth request
 * arrives as a raw axios error whose `message` is "Request failed with status
 * code 422" — the backend's real explanation sits untouched in
 * `response.data`. Every auth form used to toast the axios string.
 *
 * Note the key order: this API answers errors under `error`, and only some
 * endpoints use `message`.
 */
export const extractApiError = (err, fallback = 'Something went wrong. Please try again.') =>
  err?.response?.data?.error ||
  err?.response?.data?.message ||
  err?.message ||
  fallback;

export default extractApiError;
